import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Container, Paper, Tab, Tabs, useTheme } from '@mui/material';
import {
    CalendarMonth as CalendarMonthIcon,
    History as HistoryIcon,
} from '@mui/icons-material';
import SubscriptionReportView from './SubscriptionReportView';
import SubscriptionEventsView from './SubscriptionEventsView';

// Two views over the same subscriptions: the report reads the charged billing
// cycles, a month at a time; the events view reads the audit log.
const VIEWS = ['report', 'events'];

const ContentSubscriptionAuditPage = () => {
    const theme = useTheme();
    const [searchParams, setSearchParams] = useSearchParams();
    const view = VIEWS.includes(searchParams.get('view')) ? searchParams.get('view') : 'report';

    const changeView = (_, next) => {
        setSearchParams((current) => {
            const params = new URLSearchParams(current);
            params.set('view', next);
            return params;
        }, { replace: true });
    };

    return (
        <>
            <Container maxWidth="xl" sx={{ pt: 3 }}>
                <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${theme.palette.divider}` }}>
                    <Tabs value={view} onChange={changeView} variant="fullWidth">
                        <Tab value="report" icon={<CalendarMonthIcon />} iconPosition="start" label="Subscription Report" />
                        <Tab value="events" icon={<HistoryIcon />} iconPosition="start" label="Subscription Events" />
                    </Tabs>
                </Paper>
            </Container>
            {view === 'report' ? <SubscriptionReportView /> : <SubscriptionEventsView />}
        </>
    );
};

export default ContentSubscriptionAuditPage;
